import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["trackPerformance"],
  _excluded2 = ["data", "refetch"],
  _excluded3 = ["data", "refetch"];
const _unique = definitions => {
  const names = {};
  return definitions.filter(definition => {
    if (definition.kind !== 'FragmentDefinition') {
      return true;
    }
    const name = definition.name.value;
    if (names[name]) {
      return false;
    } else {
      names[name] = true;
      return true;
    }
  });
};
import { c as _c } from "react-compiler-runtime";
import { useCallback, useMemo, useState } from 'react';
import { useQuery, gql } from '@apollo/client';
import http from 'hub-http/clients/apiClient';
import { registerQuery, useQuery as useDFCQuery } from 'data-fetching-client';
import listingLibPerformanceTracking, { MEASURE_MARK_NAMES } from 'framework-listing-lib/internal/utils/performanceTracking';
import { makeQuickFetchRequest } from 'framework-listing-lib/utils/quickFetch';
import { Metrics } from 'framework-listing-lib/internal/metrics';
import { CRM_OBJECT_FRAGMENT } from 'framework-listing-lib/internal/graphql/fragments';
import useHasGraphQLCrmSearch from 'framework-listing-lib/internal/graphql/hooks/useHasGraphQLCrmSearch';
import useHasPulseCrmSearch from 'framework-listing-lib/internal/hooks/useHasPulseCrmSearch';
import usePulseCrmSearch from 'framework-listing-lib/internal/hooks/usePulseCrmSearch';
import { CrmSearchAllProperties, getPulseArgs } from 'framework-listing-lib/internal/resources/pulseCrmSearch';
import { transformGraphQLResponseIntoCrmSearchResponse, getGraphQLVariables } from 'framework-listing-lib/internal/graphql/utils/graphql';
export const LISTING_LIB_CRM_SEARCH_QUERY = {
  id: "marketplace-storefront-public-ui:framework-listing-lib@ListingLibCrmSearchQuery",
  kind: "Document",
  definitions: _unique([{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "ListingLibCrmSearchQuery"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "count"
        }
      },
      type: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "Int"
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "filterGroups"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "ListType",
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "FilterGroup"
              }
            }
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "objectTypeId"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "String"
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "offset"
        }
      },
      type: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "Int"
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "query"
        }
      },
      type: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "String"
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "sorts"
        }
      },
      type: {
        kind: "ListType",
        type: {
          kind: "NonNullType",
          type: {
            kind: "NamedType",
            name: {
              kind: "Name",
              value: "Sort"
            }
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "associationSpecs"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "ListType",
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "AssociationSpec"
              }
            }
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "hasAssociationSpecs"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "Boolean"
          }
        }
      },
      defaultValue: {
        kind: "BooleanValue",
        value: false
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "timeZoneId"
        }
      },
      type: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "String"
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "timeZoneSource"
        }
      },
      type: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "String"
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "crmObjectsSearch"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "count"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "count"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "filterGroups"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "filterGroups"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "offset"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "offset"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "query"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "query"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "sorts"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "sorts"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "type"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "objectTypeId"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "timeZoneId"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "timeZoneId"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "timeZoneSource"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "timeZoneSource"
            }
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "hasMore"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "offset"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "results"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "FragmentSpread",
                name: {
                  kind: "Name",
                  value: "CrmObjectFragment"
                }
              }]
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "total"
            }
          }]
        }
      }]
    }
  }].concat(CRM_OBJECT_FRAGMENT.definitions))
};
export const CRM_OBJECT_TYPE_FIELD_NAME = 'crmObjectType';
export const CRM_OBJECT_TYPE_QUERY = registerQuery({
  fieldName: CRM_OBJECT_TYPE_FIELD_NAME,
  args: ['fetcher', 'fetcherKey', 'fetchParams', 'quickFetchName', 'removeAfterFetch'],
  fetcher({
    fetcher,
    fetchParams,
    quickFetchName,
    removeAfterFetch
  }) {
    const quickFetchArg = quickFetchName || `fetch-crm-objects-${fetchParams.objectTypeId}`;
    const crmSearchRequest = () => fetcher ? fetcher(fetchParams) : http.post('/crm-search/search', {
      data: fetchParams
    });
    let performanceTracking;
    if (quickFetchArg === `fetch-crm-objects-${fetchParams.objectTypeId}`) {
      performanceTracking = listingLibPerformanceTracking.getPerformanceTracking(MEASURE_MARK_NAMES.CRM_SEARCH);
      performanceTracking.markTimeStart();
    }
    return makeQuickFetchRequest({
      makeRequestFn: crmSearchRequest,
      requestName: quickFetchArg,
      removeAfterFetch
    }).then(response => {
      Metrics.counter('crm-search-success', {
        object_type_id: fetchParams.objectTypeId
      }).increment();
      if (performanceTracking) {
        performanceTracking.markTimeEnd({
          fetch_path: 'dfc'
        });
      }
      return response;
    }).catch(error => {
      Metrics.counter('crm-search-failure', {
        object_type_id: fetchParams.objectTypeId
      }).increment();
      throw error;
    });
  }
});
function useTrackPerfEnd(variables, enabled) {
  "use memo";

  const $ = _c(4);
  const initialQuickFetch = `fetch-crm-objects-${variables.fetchParams.objectTypeId}`;
  const quickFetchArg = variables.quickFetchName || initialQuickFetch;
  const shouldTrack = enabled && quickFetchArg === initialQuickFetch;
  let performanceTracking;
  if ($[0] !== shouldTrack) {
    if (shouldTrack) {
      performanceTracking = listingLibPerformanceTracking.getPerformanceTracking(MEASURE_MARK_NAMES.CRM_SEARCH);
      performanceTracking.markTimeStart();
    }
    $[0] = shouldTrack;
    $[1] = performanceTracking;
  } else {
    performanceTracking = $[1];
  }
  let t0;
  if ($[2] !== performanceTracking) {
    t0 = () => {
      if (performanceTracking) {
        performanceTracking.markTimeEnd({
          fetch_path: "graphql"
        });
      }
    };
    $[2] = performanceTracking;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  performanceTracking;
  return t0;
}
function usePreviousDefined(value) {
  "use memo";

  const $ = _c(2);
  let t0;
  if ($[0] !== value) {
    t0 = {
      latest: value
    };
    $[0] = value;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [tracked, setTracked] = useState(t0);
  if (value !== undefined && value !== tracked.latest) {
    setTracked({
      latest: value,
      previous: tracked.latest
    });
  }
  return tracked.previous;
}
export default function useFetchFromCRM(variables, options) {
  "use memo";

  const $ = _c(68);
  const hasGraphQLCrmSearch = useHasGraphQLCrmSearch();
  const hasPulseCrmSearch = useHasPulseCrmSearch();
  let t0;
  if ($[0] !== options) {
    t0 = options || {};
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let rest;
  let shouldTrackPerformance;
  if ($[2] !== t0) {
    var _t = t0;
    ({
      trackPerformance: shouldTrackPerformance
    } = _t);
    rest = _objectWithoutPropertiesLoose(_t, _excluded);
    _t;
    $[2] = t0;
    $[3] = rest;
    $[4] = shouldTrackPerformance;
  } else {
    rest = $[3];
    shouldTrackPerformance = $[4];
  }
  let t1;
  if ($[5] !== rest || $[6] !== shouldTrackPerformance) {
    t1 = {
      incomingOptions: rest,
      trackPerformance: shouldTrackPerformance
    };
    $[5] = rest;
    $[6] = shouldTrackPerformance;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const {
    incomingOptions,
    trackPerformance
  } = t1;
  let t2;
  bb0: {
    if (hasGraphQLCrmSearch || hasPulseCrmSearch) {
      let t3;
      if ($[8] !== incomingOptions) {
        t3 = Object.assign({}, incomingOptions, {
          skip: true
        });
        $[8] = incomingOptions;
        $[9] = t3;
      } else {
        t3 = $[9];
      }
      t2 = t3;
      break bb0;
    }
    t2 = incomingOptions;
  }
  const restOptions = t2;
  let t3;
  bb1: {
    if (!hasPulseCrmSearch && hasGraphQLCrmSearch) {
      t3 = incomingOptions;
      break bb1;
    }
    let t4;
    if ($[10] !== incomingOptions) {
      t4 = Object.assign({}, incomingOptions, {
        skip: true
      });
      $[10] = incomingOptions;
      $[11] = t4;
    } else {
      t4 = $[11];
    }
    t3 = t4;
  }
  const graphQLOptions = t3;
  let t4;
  if ($[12] !== restOptions || $[13] !== variables) {
    t4 = Object.assign({
      variables
    }, restOptions);
    $[12] = restOptions;
    $[13] = variables;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  const t5 = useDFCQuery(CRM_OBJECT_TYPE_QUERY, t4);
  let data;
  let refetchDFC;
  let rest_0;
  if ($[15] !== t5) {
    var _t2 = t5;
    ({
      data,
      refetch: refetchDFC
    } = _t2);
    rest_0 = _objectWithoutPropertiesLoose(_t2, _excluded2);
    _t2;
    $[15] = t5;
    $[16] = data;
    $[17] = refetchDFC;
    $[18] = rest_0;
  } else {
    data = $[16];
    refetchDFC = $[17];
    rest_0 = $[18];
  }
  const trackPerfEnd = useTrackPerfEnd(variables, hasGraphQLCrmSearch && !hasPulseCrmSearch);
  let t6;
  if ($[19] !== variables) {
    t6 = getGraphQLVariables(variables);
    $[19] = variables;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== trackPerfEnd || $[22] !== variables) {
    t7 = () => {
      Metrics.counter("crm-search-graphql-success", {
        object_type_id: variables.fetchParams.objectTypeId
      }).increment();
      trackPerfEnd();
    };
    $[21] = trackPerfEnd;
    $[22] = variables;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] !== variables) {
    t8 = () => {
      Metrics.counter("crm-search-graphql-failure", {
        object_type_id: variables.fetchParams.objectTypeId
      }).increment();
    };
    $[24] = variables;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] !== graphQLOptions || $[27] !== t6 || $[28] !== t7 || $[29] !== t8) {
    t9 = Object.assign({
      variables: t6,
      errorPolicy: "all",
      returnPartialData: true
    }, graphQLOptions, {
      onCompleted: t7,
      onError: t8
    });
    $[26] = graphQLOptions;
    $[27] = t6;
    $[28] = t7;
    $[29] = t8;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  const t10 = useQuery(LISTING_LIB_CRM_SEARCH_QUERY, t9);
  let graphQLData;
  let refetchGraphQL;
  let restGraphQL;
  if ($[31] !== t10) {
    var _t3 = t10;
    ({
      data: graphQLData,
      refetch: refetchGraphQL
    } = _t3);
    restGraphQL = _objectWithoutPropertiesLoose(_t3, _excluded3);
    _t3;
    $[31] = t10;
    $[32] = graphQLData;
    $[33] = refetchGraphQL;
    $[34] = restGraphQL;
  } else {
    graphQLData = $[32];
    refetchGraphQL = $[33];
    restGraphQL = $[34];
  }
  let t11;
  if ($[35] !== hasPulseCrmSearch || $[36] !== incomingOptions || $[37] !== trackPerformance) {
    t11 = Object.assign({}, incomingOptions, {
      trackPerformance,
      enabled: hasPulseCrmSearch
    });
    $[35] = hasPulseCrmSearch;
    $[36] = incomingOptions;
    $[37] = trackPerformance;
    $[38] = t11;
  } else {
    t11 = $[38];
  }
  const {
    data: pulseData,
    loading: pulseLoading,
    error: pulseError,
    stale: pulseStale,
    startPolling,
    stopPolling
  } = usePulseCrmSearch(variables, t11);
  const previousPulseData = usePreviousDefined(pulseData);
  let t12;
  if ($[39] !== previousPulseData) {
    t12 = previousPulseData ? {
      [CRM_OBJECT_TYPE_FIELD_NAME]: previousPulseData
    } : undefined;
    $[39] = previousPulseData;
    $[40] = t12;
  } else {
    t12 = $[40];
  }
  const pulsePreviousData = t12;
  let t13;
  if ($[41] !== hasGraphQLCrmSearch || $[42] !== hasPulseCrmSearch || $[43] !== refetchDFC || $[44] !== refetchGraphQL || $[45] !== variables) {
    t13 = refetchVariables => {
      const finalQueryVariables = refetchVariables || variables;
      if (hasPulseCrmSearch) {
        return CrmSearchAllProperties.refetch(getPulseArgs(finalQueryVariables));
      }
      if (hasGraphQLCrmSearch) {
        return refetchGraphQL(getGraphQLVariables(finalQueryVariables));
      }
      return refetchDFC(finalQueryVariables);
    };
    $[41] = hasGraphQLCrmSearch;
    $[42] = hasPulseCrmSearch;
    $[43] = refetchDFC;
    $[44] = refetchGraphQL;
    $[45] = variables;
    $[46] = t13;
  } else {
    t13 = $[46];
  }
  const refetch = t13;
  if (hasPulseCrmSearch) {
    let t14;
    if ($[47] !== pulseData || $[48] !== pulseError || $[49] !== pulseLoading || $[50] !== pulsePreviousData || $[51] !== pulseStale || $[52] !== refetch || $[53] !== startPolling || $[54] !== stopPolling || $[55] !== variables) {
      t14 = {
        data: pulseData,
        loading: pulseLoading,
        error: pulseError,
        stale: pulseStale,
        client: undefined,
        variables,
        previousData: pulsePreviousData,
        refetch,
        startPolling,
        stopPolling
      };
      $[47] = pulseData;
      $[48] = pulseError;
      $[49] = pulseLoading;
      $[50] = pulsePreviousData;
      $[51] = pulseStale;
      $[52] = refetch;
      $[53] = startPolling;
      $[54] = stopPolling;
      $[55] = variables;
      $[56] = t14;
    } else {
      t14 = $[56];
    }
    return t14;
  }
  if (hasGraphQLCrmSearch) {
    let t14;
    if ($[57] !== graphQLData || $[58] !== variables.fetchParams.objectTypeId) {
      t14 = transformGraphQLResponseIntoCrmSearchResponse(graphQLData, variables.fetchParams.objectTypeId);
      $[57] = graphQLData;
      $[58] = variables.fetchParams.objectTypeId;
      $[59] = t14;
    } else {
      t14 = $[59];
    }
    let t15;
    if ($[60] !== refetch || $[61] !== restGraphQL || $[62] !== t14) {
      t15 = Object.assign({
        data: t14,
        refetch
      }, restGraphQL);
      $[60] = refetch;
      $[61] = restGraphQL;
      $[62] = t14;
      $[63] = t15;
    } else {
      t15 = $[63];
    }
    return t15;
  }
  const t14 = data && CRM_OBJECT_TYPE_FIELD_NAME in data ? data[CRM_OBJECT_TYPE_FIELD_NAME] : undefined;
  let t15;
  if ($[64] !== refetch || $[65] !== rest_0 || $[66] !== t14) {
    t15 = Object.assign({
      data: t14,
      refetch
    }, rest_0);
    $[64] = refetch;
    $[65] = rest_0;
    $[66] = t14;
    $[67] = t15;
  } else {
    t15 = $[67];
  }
  return t15;
}